import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
// import JwtService from "@/core/services/jwt.service";
// import axios from "axios";

// action types
export const UPDATE_TABLE_STRUCTURE = "getINVOICESTableStructure";
export const UPDATE_TABLE_DATA = "getINVOICESTableData";
export const EXPORT_TABLE_DATA = "exportINVOICESTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setINVOICESTableStructure";
export const SET_TABLE_DATA = "setINVOICESTableData";
export const SET_TABLE_FILTER = "setINVOICESTableFilter";
export const SET_TABLE_PAGE = "setINVOICESTablePage";
export const SET_TABLE_PERPAGE = "setINVOICESTablePerPage";
export const SET_TABLE_SORTBY = "setINVOICESTableSortBy";
export const SET_TABLE_SORTORDER = "setINVOICESTableSortOrder";
export const SET_EXPORT_LINK = "setINVOICESExportLink";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  sync_types: [],
  clients: [],
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  /**
   * for table title, descripton
   * */
  getINVOICESTableProperties(state) {
    return state.table_structure.properties;
  },
  /**
   * for table permissions
   **/
  getINVOICESTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getINVOICESTableState(state) {
    // console.log("table state is ", state.table_state);
    return state.table_state;
  },

  getINVOICESTableHeaders(state) {
    return state.table_structure.columns;
  },

  getINVOICESTableFilters(state) {
    return state.table_structure.filters;
  },

  getINVOICESTableData(state) {
    return state.table_data.data;
  },

  getINVOICESExportUrl(state) {
    return state.export_link;
  },
  getINVOICESTableStructure(state) {
    return state.table_structure;
  },
  getINVOICESSyncTypes(state) {
    return state.sync_types;
  },
  getINVOICESClients(state) {
    return state.clients;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    // console.log(payload);
    return new Promise((resolve) => {
      ApiService.post("/cod/invoices")
        .then(({ data }) => {
          // console.log("suc", data);
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      // ApiService.post("login", credentials)
      ApiService.post("/cod/invoices/datatable", payload)
        .then(({ data }) => {
          // console.log("data of datatable ", data);
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/cod/invoices/export", payload)
        .then(({ data }) => {
          // console.log("export data is ", data);
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
    if (table_structure.data && table_structure.data.sync_types) {
      state.sync_types = table_structure.data.sync_types;
    }
    if (table_structure.data && table_structure.data.clients) {
      state.clients = table_structure.data.clients;
    }
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
